import { createSelector } from 'reselect';
import { parseISO } from 'date-fns';

import { reportsTransactions as reportsTransactionsEntity } from 'store/saga/entities/bound';

export const selectReportsTransactionsIsLoading = state =>
  !reportsTransactionsEntity.loaded(state) || reportsTransactionsEntity.loading(state);

const selectReportsTransactionsIsLoaded = state => reportsTransactionsEntity.loaded(state);

const selectReportsTransactionsData = state => reportsTransactionsEntity.data(state);

export const selectReportsTransactionsSummary = createSelector(
  selectReportsTransactionsIsLoaded,
  selectReportsTransactionsData,
  (isLoaded, reportsTransactionsData) => {
    if (!isLoaded) {
      return {
        totalAmount: undefined,
        currencyCode: undefined,
        taxElementsIncluded: false,
        revenueFromTransactions: undefined,
        taxAmount: undefined,
      };
    }

    const { totalConverted: totalAmount, currencyCode } = reportsTransactionsData;

    if (!reportsTransactionsData.taxElementsIncluded) {
      return {
        totalAmount,
        currencyCode,
        taxElementsIncluded: false,
        revenueFromTransactions: 0,
        taxAmount: 0,
      };
    }

    const { unitAmount: revenueFromTransactions, taxAmount } = reportsTransactionsData;

    return {
      totalAmount,
      currencyCode,
      taxElementsIncluded: true,
      revenueFromTransactions,
      taxAmount,
    };
  }
);

export const selectReportsTransactions = createSelector(
  selectReportsTransactionsIsLoaded,
  selectReportsTransactionsData,
  (isLoaded, reportsTransactionsData) =>
    isLoaded
      ? {
          ...reportsTransactionsData.pageInfo,
          transactions: reportsTransactionsData.transactions
            .sort((a, b) => {
              const dateA = parseISO(a.effectiveDate);
              const dateB = parseISO(b.effectiveDate);
              return dateA - dateB;
            })
            .map(transaction => ({
              ...transaction,
              dateTime:
                transaction.startDate && transaction.startTime
                  ? parseISO(`${transaction.startDate} ${transaction.startTime}`)
                  : undefined,
              userName: `${transaction.firstName} ${transaction.lastName}`,
            })),
        }
      : {}
);

// reducer fields

export const selectPayoutTransactionControls = state => state.payoutTransaction;
